const DASHBOARD_ROUTES = Object.freeze({
	root: {
		name: 'Dashboard',
		path: '/dashboard',
		meta: {
			layout: 'Default',
			requiresAuth: true,
		},
		redirect: {
			name: 'Index',
		},
		component: () => import('@/presentation/modules/dashboard/views/RootView.vue'),
	},
	indexDashboard: {
		name: 'Index',
		path: '',
		component: () => import('@/presentation/modules/dashboard/views/DashboardIndexView.vue'),
	},
	businessGuide: {
		name: 'BusinessGuide',
		path: 'guide',
		component: () => import('@/presentation/modules/dashboard/views/BusinessGuideView.vue'),
		meta: {
			layout: 'Default',
			requiresAuth: true,
			allowedRoles: ['Business'],
		},
	},
	financialDashboard: {
		name: 'DashboardFinancial',
		path: 'financial',
		component: () => import('@/presentation/components/dashboard/financial-management/DashboardFinancialManagement.vue'),
		meta: {
			layout: 'Default',
			requiresBusinessInfo: true,
			requiredEntitlement: 'AdvancedFinancialReportsEnabled',
		},
	},
	businessOnboarding: {
		name: 'BusinessOnboarding',
		path: 'business-onboarding',
		component: () => import('@/presentation/modules/dashboard/views/BusinessOnboardingView.vue'),
		meta: {
			layout: 'Default',
			requiresAuth: true,
		},
	},
	wallet: {
		name: 'DashboardWallet',
		path: 'wallet',
		component: () => import('@/presentation/modules/dashboard/views/WalletView.vue'),
		meta: {
			layout: 'Default',
		},
	},
	withdraw: {
		name: 'DashboardWithdraw',
		path: 'withdraw',
		component: () => import('@/presentation/modules/dashboard/views/WithdrawView.vue'),
		meta: {
			layout: 'Simple',
		},
	},
	creditCharge: {
		name: 'DashboardCreditCharge',
		path: 'credit-charge',
		component: () => import('@/presentation/modules/dashboard/views/CreditChargeView.vue'),
		meta: {
			layout: 'Simple',
		},
	},
	customers: {
		name: 'DashboardCustomers',
		path: 'customers',
		component: () => import('@/presentation/modules/dashboard/views/CustomersView.vue'),
		meta: {
			layout: 'Default',
			requiresBusinessInfo: true,
		},
	},
	customerClub: {
		name: 'DashboardCustomerClub',
		path: 'customer-club',
		component: () => import('@/presentation/modules/dashboard/views/CustomerClubView.vue'),
		meta: {
			layout: 'Default',
			requiresBusinessInfo: true,
			requiredEntitlement: 'CustomerClubEnabled',
		},
	},
	marketingCampaigns: {
		name: 'DashboardMarketingCampaigns',
		path: 'marketing-campaigns',
		component: () => import('@/presentation/modules/dashboard/views/MarketingCampaignsView.vue'),
		meta: {
			layout: 'Default',
			requiresBusinessInfo: true,
			allowedRoles: ['Business'],
			requiredEntitlement: 'CustomerClubEnabled',
		},
	},
	specialOffers: {
		name: 'DashboardSpecialOffers',
		path: 'special-offers',
		component: () => import('@/presentation/modules/dashboard/views/SpecialOffersView.vue'),
		meta: { layout: 'Default', requiresBusinessInfo: true, allowedRoles: ['Business'] },
	},
	subscription: {
		name: 'DashboardSubscription',
		path: 'subscription',
		component: () => import('@/presentation/modules/dashboard/views/subscription/SubscriptionView.vue'),
		meta: {
			layout: 'Simple',
			requiresBusinessInfo: true,
			allowedRoles: ['Business'],
		},
	},
	settingRoot: {
		name: 'DashboardSettingRoot',
		path: 'setting',
		component: () => import('@/presentation/modules/dashboard/views/setting/SettingRootView.vue'),
		meta: {
			requiresBusinessInfo: true,
		},
	},
	setting: {
		name: 'DashboardSetting',
		path: '',
		component: () => import('@/presentation/modules/dashboard/views/setting/SettingView.vue'),
	},

	identityInformation: {
		name: 'DashboardIdentityInformation',
		path: 'identity-information',
		component: () => import('@/presentation/modules/dashboard/views/setting/IdentityInformationView.vue'),
		meta: {
			layout: 'Simple',
			requiresBusinessInfo: true,
		},
	},

	artists: {
		name: 'DashboardArtists',
		path: 'artists',
		component: () => import('@/presentation/modules/dashboard/views/setting/artist-view/ArtistView.vue'),
		meta: {
			layout: 'Default',
		},
	},

	updateArtists: {
		name: 'DashboardUpdateArtist',
		path: 'artist/:artistId',
		component: () => import('@/presentation/modules/dashboard/views/setting/artist-view/AssignService.vue'),
		meta: {
			layout: 'Simple',
		},
	},

	createArtists: {
		name: 'DashboardCreateArtist',
		path: 'artist/:shopId/create',
		component: () => import('@/presentation/modules/dashboard/views/setting/artist-view/CreateArtistView.vue'),
		meta: {
			layout: 'Simple',
		},
	},

	services: {
		name: 'DashboardServices',
		path: 'services',
		component: () => import('@/presentation/modules/dashboard/views/setting/service-view/ServiceView.vue'),
		meta: {
			layout: 'Default',
		},
	},

	serviceArtistAssignments: {
		name: 'DashboardServiceArtistAssignments',
		path: 'service-artist-assignments',
		component: () => import('@/presentation/modules/dashboard/views/setting/ServiceArtistAssignmentsView.vue'),
		meta: {
			layout: 'Simple',
		},
	},

	messageManager: {
		name: 'DashboardMessageManager',
		path: 'message-manager',
		component: () => import('@/presentation/modules/dashboard/views/setting/sms-template/MessageManagerView.vue'),
		meta: {
			layout: 'Simple',
		},
	},

	category: {
		name: 'DashboarCcategory',
		path: 'category',
		component: () => import('@/presentation/modules/dashboard/views/setting/CategoryView.vue'),
		meta: {
			layout: 'Simple',
		},
	},

	sendSms: {
		name: 'DashboardSendSms',
		path: 'send-sms',
		component: () => import('@/presentation/modules/dashboard/views/setting/SendSmsView.vue'),
		meta: {
			layout: 'Simple',
			requiredEntitlement: 'BulkSmsEnabled',
		},
	},

	businessSetupSteps: {
		name: 'BusinessSetupSteps',
		path: 'setup-business',
		component: () => import('@/presentation/modules/dashboard/views/setting/BusinessSetupSteps.vue'),
		meta: {
			layout: 'Simple',
			requiresBusinessInfo: true,
		},
	},

	requestRoot: {
		name: 'DashboardRequestRoot',
		path: 'requests',
		component: () => import('@/presentation/modules/dashboard/views/requests/RequestRootView.vue'),
		meta: {
			requiresAuth: true,
			requiresBusinessInfo: true,
			layout: 'Simple',
		},
	},
	request: {
		name: 'DashboardRequests',
		path: '',
		component: () => import('@/presentation/modules/dashboard/views/requests/RequestView.vue'),
		meta: {
			layout: 'Simple',
		},
	},
	receiveRequests: {
		name: 'DashboardReceiveRequests',
		path: 'receive-requests',
		component: () => import('@/presentation/modules/dashboard/views/requests/ReceiveRequestsView.vue'),
		meta: {
			layout: 'Default',
		},
	},
	sendRequests: {
		name: 'DashboardSendRequests',
		path: 'send-requests',
		component: () => import('@/presentation/modules/dashboard/views/requests/SendRequestsView.vue'),
		meta: {
			layout: 'Default',
		},
	},

	bookAppointment: {
		name: 'BookAppointment',
		path: 'book',
		component: () => import('@/presentation/modules/dashboard/views/requests/BookAppointmentView.vue'),
		meta: {
			layout: 'Simple',
		},
	},

	adminRoot: {
		path: 'admin',
		name: 'DashboardAdminRoot',
		meta: {
			requiresAuth: true,
			allowedRoles: ['Admin'],
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/RootView.vue'),
	},

	adminIndex: {
		name: 'DashboardAdmin',
		path: '',
		meta: {
			requiresAuth: true,
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/AdminIndexView.vue'),
	},

	adminBusiness: {
		name: 'DashboardAdminBusiness',
		path: 'business',
		meta: {
			layout: 'Simple',
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/BusinessView.vue'),
	},

	adminBusinessDetail: {
		name: 'DashboardAdminBusinessDetail',
		path: 'bussines/:businessId',
		props: (route) => ({
			detail: route.params.detail,
		}),
		meta: {
			layout: 'Simple',
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/DetailBusiness.vue'),
	},

	adminBusinessEdit: {
		name: 'DashboardAdminBusinessEdit',
		path: 'business/:businessId/edit',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/EditBusiness.vue'),
	},

	adminSmsPlan: {
		name: 'adminSmsPlan',
		path: 'sms-plan',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/sms-plan/SmsPlanView.vue'),
	},

	adminSystemSmsTemplates: {
		name: 'adminSystemSmsTemplates',
		path: 'system-sms-templates',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
			allowedRoles: ['Admin'],
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/AdminSystemSmsTemplatesView.vue'),
	},

	adminCategories: {
		name: 'adminCategories',
		path: 'categories',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
			allowedRoles: ['Admin'],
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/CategoryManagementView.vue'),
	},

	adminTransferFee: {
		name: 'adminTransferFee',
		path: 'transfer-fee',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/TransferFeeView.vue'),
	},
	adminSubscriptionPlans: {
		name: 'adminSubscriptionPlans',
		path: 'subscription-plans',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
			allowedRoles: ['Admin'],
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/subscription/SubscriptionPlansView.vue'),
	},
	adminDisputes: {
		name: 'adminDisputes',
		path: 'disputes',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/AdminDisputesView.vue'),
	},

	adminWithdraw: {
		name: 'adminWithdraw',
		path: 'withdraw',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/WithdrawRequestsView.vue'),
	},

	adminCreditSms: {
		name: 'adminCreditSms',
		path: 'credit-sms',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/CreditChargeView.vue'),
	},

	adminPushNotifications: {
		name: 'adminPushNotifications',
		path: 'push-notifications',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
			allowedRoles: ['Admin'],
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/PushNotificationsView.vue'),
	},
	adminSecurity: {
		name: 'adminSecurity',
		path: 'security',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
			allowedRoles: ['Admin'],
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/AdminSecurityView.vue'),
	},
	adminMarketingCampaigns: {
		name: 'adminMarketingCampaigns',
		path: 'marketing-campaigns',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
			allowedRoles: ['Admin'],
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/MarketingCampaignsView.vue'),
	},
	adminPartners: {
		name: 'adminPartners',
		path: 'partners',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
			allowedRoles: ['Admin'],
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/PartnerManagementView.vue'),
	},
	partnerDashboard: {
		name: 'partnerDashboard',
		path: 'partner',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
			allowedRoles: ['Partner'],
		},
		component: () => import('@/presentation/modules/dashboard/views/partner/PartnerDashboardView.vue'),
	},
	adminGrowthCenter: {
		name: 'adminGrowthCenter',
		path: 'growth-center',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
			allowedRoles: ['Admin'],
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/growth-center/OverviewView.vue'),
	},
	adminGrowthCenterAcquisition: {
		name: 'adminGrowthCenterAcquisition',
		path: 'growth-center/acquisition',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
			allowedRoles: ['Admin'],
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/growth-center/AcquisitionView.vue'),
	},
	adminGrowthCenterMarketplaceHealth: {
		name: 'adminGrowthCenterMarketplaceHealth',
		path: 'growth-center/marketplace-health',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
			allowedRoles: ['Admin'],
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/growth-center/MarketplaceHealthView.vue'),
	},
	adminGrowthCenterRevenue: {
		name: 'adminGrowthCenterRevenue',
		path: 'growth-center/revenue',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
			allowedRoles: ['Admin'],
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/growth-center/RevenueView.vue'),
	},
	adminGrowthCenterCampaigns: {
		name: 'adminGrowthCenterCampaigns',
		path: 'growth-center/campaigns',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
			allowedRoles: ['Admin'],
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/growth-center/CampaignsView.vue'),
	},
	adminGrowthCenterCampaignDetails: {
		name: 'adminGrowthCenterCampaignDetails',
		path: 'growth-center/campaigns/:campaignId',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
			allowedRoles: ['Admin'],
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/growth-center/CampaignDetailsView.vue'),
	},
	adminGrowthCenterEventRules: {
		name: 'adminGrowthCenterEventRules',
		path: 'growth-center/event-rules',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
			allowedRoles: ['Admin'],
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/growth-center/EventRulesView.vue'),
	},
	adminGrowthCenterSms: {
		name: 'adminGrowthCenterSms',
		path: 'growth-center/sms',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
			allowedRoles: ['Admin'],
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/growth-center/SmsView.vue'),
	},
	adminGrowthCenterCustomers: {
		name: 'adminGrowthCenterCustomers',
		path: 'growth-center/customers',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
			allowedRoles: ['Admin'],
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/growth-center/CustomersView.vue'),
	},
	adminGrowthCenterCohorts: {
		name: 'adminGrowthCenterCohorts',
		path: 'growth-center/cohorts',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
			allowedRoles: ['Admin'],
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/growth-center/CohortsView.vue'),
	},
	adminGrowthCenterInsights: {
		name: 'adminGrowthCenterInsights',
		path: 'growth-center/insights',
		meta: {
			layout: 'Simple',
			requiresAuth: true,
			allowedRoles: ['Admin'],
		},
		component: () => import('@/presentation/modules/dashboard/views/admin/growth-center/InsightsView.vue'),
	},
});

export default DASHBOARD_ROUTES;
